import React from 'react';

import TermsOfService from '../../components/TermsOfService';

const styles = {
  form: {},
};
export default class ClassAppTermsOfService extends React.Component {
  render() {
    return (
      <div style={styles.form}>
        <TermsOfService />
      </div>
    );
  }
}
